import { APICore } from './apiCore';

const api = new APICore();


/* CREATE REPLY */
export function CreateKnowledgebase(formData: FormData): Promise<any> {
    return api.create('/ai/ingest', formData);
}

/* LIST */
export function list_knowledgebase() {
    return api.show('/knowledgebase/list');
}

/* DETAILS */

export function delete_knowledgebase(id: string) {
    return api.get(`/knowledgebase/${id}`);
}

/* UPDATE */
export function update_keyword(id: string, data: FormData) {
    return api.create(`/keyword_action/${id}`, data);
}
